import type { JSX } from "react";

import Box from "@mui/material/Box";
import {
  Edit,
  type EditControlProps,
} from "@plansoft-configuration-renderer/components";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";

export function CustomEdit(props: EditControlProps): JSX.Element {
  const { properties } = useCsAttribute();
  const backgroundColor = properties?.editFieldBackgroundColor?.value;

  if (!backgroundColor) {
    return <Edit {...props} />;
  }

  return (
    <Box sx={{ "& .MuiInputBase-root": { backgroundColor } }}>
      <Edit {...props} />
    </Box>
  );
}
